import React from "react";
import { ModalContentWrapper } from "../../../../shared/Modal/ModalContentWrapper/ModalContentWrapper";
import { FlexCenter } from "../../../../layout/FlexCenter/FlexCenter";
import { GridTable } from "../../../../layout/GridTable/GridTable";
import { ScrollY } from "../../../../layout/Scroll/ScrollY";
import { TextCustom } from "../../../../ui/TextCustom";
import { ExecButton } from "../../../../ui/ExecButton/ExecButton";
import { ErrorNotification } from "../../../../shared/ErrorNotification/ErrorNotification";
import { SpacingCustom } from "../../../../layout/Spacing/SpacingCustom";
import { Loader } from "../../../../shared/Loader/Loader";
import { ScriptUpdateCard } from "./scriptUpdateCard";
import { useMergedScripts } from "./hooks/useMergedScripts";
import { FlexBetween } from "../../../../layout/FlexBetween/FlexBetween";
import { PanelLayout } from "../../../../layout/Panel/Panel";
import { Spacing } from "../../../../layout/Spacing/Spacing";

interface IScriptSettingsModalContentProps {
    socketRef: React.MutableRefObject<WebSocket | null>,
    isReady: boolean
}

export const ScriptSettingsModalContent:React.FC<IScriptSettingsModalContentProps> = ({socketRef, isReady}) => {


    const {
        mergedScripts, 
        scriptUpdateManagerData, 
        scriptUpdateWsData, 
        scriptUpdateManagerError, 
        scriptUpdateManagerLoading, 
        createScriptCards, 
        onReloadScripts,
        onUpdateScripts,
        onRevealInFileExplorer
    } = useMergedScripts(socketRef, isReady)


    const getScriptsCards = createScriptCards.map((scriptCardItem) => {
        
        return  <ScriptUpdateCard
                    shouldUpdate = {scriptCardItem.shouldUpdate} 
                    isOnlyLocal={scriptCardItem.isOnlyLocal} 
                    key={scriptCardItem.index} 
                    index={scriptCardItem.index} 
                    localVersion={scriptCardItem.localVersion} 
                    gitVersion={scriptCardItem.gitVersion} 
                    script={scriptCardItem.script} 
                    scriptUpdateWsData={mergedScripts} 
                    noVersion = {scriptCardItem.noVersion}
                    gitStatus = {scriptCardItem.gitStatus}
                    localStatus={scriptCardItem.localStatus}
                />
    });
    
    const numOfUpdates = createScriptCards.filter((scriptCardItem) => scriptCardItem.shouldUpdate).length;

    return (
            <ModalContentWrapper title={"Script versions"} iconName="Configure_green" hasIcon>
                <FlexCenter stretch gap={2} direction="h" position="start">
                        { 
                            scriptUpdateManagerData.length !== 0
                            ?
                            <>
                                <GridTable gridTemplateColumns='400px 100px 100px' hasSeparator = {false}>
                                    <TextCustom color="grey-dark" size={1.2} weight={700}>Scripts</TextCustom>
                                    <TextCustom color="grey-dark" size={1.2} weight={700}>Local version</TextCustom>
                                    <TextCustom color="grey-dark" size={1.2} weight={700}>Git version</TextCustom>
                                </GridTable>

                                <ScrollY height={300}>
                                    {
                                        scriptUpdateManagerError
                                        ?
                                        <div style={{width:'600px', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                            <ErrorNotification error={""} text={"Error while getting scripts version."} textSize={1.2}/>
                                        </div>
                                        :
                                            scriptUpdateManagerLoading
                                            ?
                                            <div style={{width:'600px', height:'100%', display:'flex', justifyContent:'center', alignItems:'center'}}>
                                                <Loader width={30} height={30} color="accent-green" label={"Loading script versions"} />
                                            </div>
                                            :
                                            <FlexCenter stretch direction='h' position='end' gap={.5}>
                                                {getScriptsCards}
                                            </FlexCenter>
                                    }
                                </ScrollY>
                            </>
                            :
                            <div style={{width:'600px'}}>
                                <SpacingCustom paddingTop={8} paddingBottom={8}>
                                    <ErrorNotification error={""} text={"Script list is empty."} textSize={1.2}/>
                                </SpacingCustom>
                            </div>
                        }
                    <SpacingCustom paddingTop={2} stretch>
                        <FlexCenter position="start" gap={1}>
                                <FlexCenter stretch direction="v" position="end" gap={1}>
                                    <ExecButton label={`Update scripts`} iconName={"Download"}  func={onUpdateScripts}/>
                                    <ExecButton label={"Reload scripts"} iconName={"Refresh"}  func={()=>onReloadScripts()}/>
                                    <ExecButton label={`Reveal in File Explorer`} iconName={"Scanprojectstructure_data"}  func={onRevealInFileExplorer}/>
                                </FlexCenter>
                                {
                                    numOfUpdates !== 0
                                    ?
                                    <FlexCenter position="start" direction="v" gap={0.5}>
                                        <TextCustom color='grey-dark' size={1.1} weight={400}>You need to update</TextCustom>
                                        <TextCustom color="accent-green" size={1.1} weight={700}>{numOfUpdates}</TextCustom>
                                        <TextCustom color="grey-dark" size={1.1} weight={400}>script{numOfUpdates !== 1 ? 's' : ''}</TextCustom>
                                    </FlexCenter>
                                    :
                                    <FlexCenter position="start" direction="v" gap={0.5}>
                                        <TextCustom color='grey-dark' size={1.1} weight={400}>Everything is up to date.</TextCustom>
                                    </FlexCenter>
                                }
                        </FlexCenter>
                    </SpacingCustom>
                </FlexCenter>
            </ModalContentWrapper>
    )
}